import { render, staticRenderFns } from "./ResourceCreateAdmin.vue?vue&type=template&id=3a7b92d8&"
import script from "./ResourceCreateAdmin.vue?vue&type=script&lang=js&"
export * from "./ResourceCreateAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7b92d8')) {
      api.createRecord('3a7b92d8', component.options)
    } else {
      api.reload('3a7b92d8', component.options)
    }
    module.hot.accept("./ResourceCreateAdmin.vue?vue&type=template&id=3a7b92d8&", function () {
      api.rerender('3a7b92d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/steps/ResourceCreateAdmin.vue"
export default component.exports